import DialogContent from "@material-ui/core/DialogContent";
import {Button, Divider, Grid, Typography} from "@material-ui/core";
import RequestOfferForm from "./RequestOfferForm";
import DialogActions from "@material-ui/core/DialogActions";
import React, {useEffect, useRef, useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import CustomDialog from "../Shared/Components/CustomDialog";
import TextField from "@material-ui/core/TextField/TextField";
import {useDispatch} from "react-redux";
import {sendReceiveOfferRequest} from "../reducers/Configuration/Actions";


const useStyles = makeStyles((theme) => ({
    checkboxLabel: {
        fontSize: 15,
        paddingLeft: 15,
        paddingBottom: 12,
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 12,
        },
    },
    checkbox: {
        alignSelf: 'flex-start',
        top: -10,
    },
    formHelperText: {
        marginLeft: 45,
        marginBottom: 15,
    },
    receiveOfferFormContainer: {
        paddingLeft: '20px',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: 0,
        },
    },
    titleTypography: {
        paddingBottom: 16,
    },
    addToCart: {
        height: 40,
        color: "#fff",
        minWidth: 140,
        textTransform: "none",
        fontWeight: "bold",
        "&:hover": {
            opacity: 0.6,
        },
        "&.Mui-disabled": {
            opacity: 0.3,
            color: "#fff",
        },
    },
    MuiFormControlRoot: {
        display: 'flex !important',
        [theme.breakpoints.up('sm')]: {
            marginTop: 15,
            marginBottom: 20,
        },
        '& label': {
            fontSize: 15,
        },
    },
}));

const RequestOfferDialog = (props) => {
    const classes = useStyles();
    const { t } = useTranslation(["receiveOfferForm"]);
    const dispatch = useDispatch();
    const formRef = useRef();

    const {
        onClose,
        formattedPriceElement,
    } = props;

    const [annotation, setAnnotation] = useState("");
    const [hasErrorReceiveOfferForm, setHasErrorReceiveOfferForm] = useState(null);
    const [verifyRequestErrors, setVerifyRequestErrors] = useState(null);

    const handleSendOfferRequest = async () => {
        const formValidation = formRef.current.validateForm();
        if (formValidation && formValidation.hasError) {
            setHasErrorReceiveOfferForm(formValidation.hasError)
        } else if (formValidation && !formValidation.hasError) {
            const result = await dispatch(sendReceiveOfferRequest(formValidation));
            setVerifyRequestErrors(result);
        }
    }

    return (
        <CustomDialog
            open={true}
            dialogTitle={t("label")}
            onCancel={onClose}
            onClose={onClose}
            aria-labelledby="request-dialog-title"
            aria-describedby="request-dialog-description"
        >
            { verifyRequestErrors !== null &&
                <DialogContent>
                    <Typography variant="body2">
                        {verifyRequestErrors ? t('sentOk') : t('sentError')}
                    </Typography>
                </DialogContent>
            }
            { verifyRequestErrors === null &&
                (<div>
                    <DialogContent>
                        {hasErrorReceiveOfferForm && (
                            <Typography color="error" variant="body2">
                                {t('checkInputsInForm')}
                            </Typography>
                        )}
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography className={classes.titleTypography}>
                                    <b>{t("data")}</b>
                                </Typography>
                                <RequestOfferForm ref={formRef}/>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label={t("annotation")}
                                    multiline
                                    rows="3"
                                    rowsMax="3"
                                    value={annotation}
                                    onChange={(e) => setAnnotation(e.target.value)}
                                    margin="normal"
                                    variant="outlined"
                                    classes={{
                                        root: classes.MuiFormControlRoot,
                                    }}
                                />
                                <Divider />
                                {formattedPriceElement()}
                                <Divider />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            className={clsx(classes.addToCart, "primaryButton")}
                            onClick={handleSendOfferRequest}
                            color="primary"
                            fullWidth
                        >
                            {t("label")}
                        </Button>
                    </DialogActions>
                </div>)
            }
        </CustomDialog>
    )
};

export default RequestOfferDialog
